import { ACCOUNTING_OPTIONS } from './accounting';
import { INSURANCE_OPTIONS } from './insurance';

export const SYSTEM_OPTIONS = {
  'accounting-dashboard': ACCOUNTING_OPTIONS,
  insurance: INSURANCE_OPTIONS,
};

export type LinkRoot = keyof typeof SYSTEM_OPTIONS;
